export interface Section {
  type: string;
  title: string;
  items?: string[] | Section[];
  listType?: string;
  headers?: string[];
  rows?: string[][];
  src?: string;
}

export interface HtmlJSONModel {
  html: string;
  type: number[];
  sections: Section[];
}

export function jsonToHTML(json: HtmlJSONModel): string {
  let htmlOutput = `<div class="content-wrapper">`;
  htmlOutput += formatSectionsToHtml(json.sections); // fix: += instead of overwriting
  htmlOutput += `</div>`;
  return htmlOutput;
}

function formatSectionsToHtml(sections: Section[]) {
  let htmlOutput = '';
  sections.forEach(section => {
    const isEmptyTable = section.type === 'TABLE' && section.rows && section.rows.length == 0 //Ignore empty table
    if(!isEmptyTable){
      htmlOutput += `<div class="section my-6 first:mt-8"><h2 class="text-lg font-medium mb-2 break-after-avoid">${formatTextContent(section.title)}</h2>`;
      htmlOutput += formatSectionToHtml(section);
      htmlOutput += `</div>`; // Close section div
    }
  });
  return htmlOutput;
}

function formatTextContent(input: string): string {
  if (!input) return '';  
  // Bold: **text**
  let formatted = input.replace(/\*\*(.*?)\*\*/g, '<span class="font-bold">$1</span>');
  // Additional markdown styles can be added here if needed 
  return formatted;
}

function formatSectionToHtml(section: Section) {
  let htmlOutput = '';
  switch (section.type) {
    case "PARAGRAPH":
      section.items?.forEach((item:any) => {
        htmlOutput += `<p class="mb-[4px]">${formatTextContent(item)}</p>`;
      });
      break;

    case "LIST":
      const listTag = section.listType === "ORDER_LIST" ? 'ol' : 'ul';
      htmlOutput += `<${listTag} class="list-disc pl-5">`;
      section.items?.forEach(item => {
        if (typeof item === "object") {
          htmlOutput += `<li class="font-medium list-decimal mb-1">${formatTextContent(item.title)}</li>`;
          htmlOutput += formatSectionToHtml(item);
        } else {
          htmlOutput += `<li class="mb-[2px] last:mb-2">${formatTextContent(item)}</li>`;
        }
      });
      htmlOutput += `</${listTag}>`;
      break;

    case "TABLE":
      if (section.rows && section.rows.length > 0) {
        htmlOutput += `<table class="mt-4 border border-collapse border-gray-300"><tr>`;
        section.headers?.forEach(header => {
          htmlOutput += `<th class="border p-2 bg-[#5c2d91] text-white">${formatTextContent(header)}</th>`;
        });
        htmlOutput += `</tr>`;
        section.rows?.forEach(row => {
          htmlOutput += `<tr class="odd:bg-slate-100">`;
          row.forEach(cell => {
            const cellClass = cell?.toString().toLowerCase() === 'mismatch' ? 'text-red-600' : '';
            htmlOutput += `<td class="${cellClass} border p-2">${formatTextContent(cell)}</td>`;
          });
          htmlOutput += `</tr>`;
        });
        htmlOutput += `</table>`;
      }
      break;

    case "IMAGE":
      htmlOutput += `<img src="${section.src}" alt="${formatTextContent(section.title)}">`;
      break;

    default:
      htmlOutput += `<div>Unknown section type</div>`;
      break;
  }
  return htmlOutput;
}

function splitContentByColon(input: string): string {
  const hasColon = input.includes(":");
  if (!hasColon) {
    return formatTextContent(input);
  }
  const splitIndex = input.indexOf(":");
  const title = input.slice(0, splitIndex);
  const content = input.slice(splitIndex + 1);
  return `<span class="font-medium mr-2">${formatTextContent(title)}:</span><span>${formatTextContent(content)}</span>`;
}
